import { render } from "./MetricGroupsCommentsStatistic.vue?vue&type=template&id=74d2ae02&scoped=true"
import script from "./MetricGroupsCommentsStatistic.vue?vue&type=script&lang=js"
export * from "./MetricGroupsCommentsStatistic.vue?vue&type=script&lang=js"

import "./MetricGroupsCommentsStatistic.vue?vue&type=style&index=0&id=74d2ae02&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d2ae02"]])

export default __exports__